import React, { useCallback, useEffect, useState } from 'react';
import { Container, ContainerInterno } from '../styles';
import api from '../../../services/api';
import { NotificationManager } from 'react-notifications';
import RModal from '../../../components/Rsuite/Modal';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomInput } from '../../../components/CustomInput';
import { CustomButton } from '../../../components/CustomButton';
import { useCustomTheme } from '../../../hooks/useCustomTheme';

const EditarCadastrarRegiao = ({
  modal,
  close,
  regiao,
  setRegioes,
  id_empresa,
}) => {
  const [idRegiao, setIdRegiao] = useState(null);
  const [descricao, setDescricao] = useState('');
  const [taxaGratis, setTaxaGratis] = useState(0);
  const [ativo, setAtivo] = useState(0);
  const { theme } = useCustomTheme();

  const data = [
    { value: 1, label: 'Sim' },
    { value: 0, label: 'Não' },
  ];

  const cadastrar = useCallback(async () => {
    await api
      .post('regiao/criar', {
        IdEmpresa: id_empresa,
        Descricao: descricao,
        TaxaGratis: taxaGratis,
      })
      .then((res) => {
        NotificationManager.success('Horário cadastrado', 'Sucesso');
        setRegioes((state) => [...state, res.data]);
        close();
      });
  }, [close, descricao, id_empresa, setRegioes, taxaGratis]);

  const editar = useCallback(async () => {
    await api
      .patch(`regiao/alterar/${idRegiao}`, {
        IdEmpresa: id_empresa,
        Descricao: descricao,
        TaxaGratis: taxaGratis,
        Ativo: ativo,
      })
      .then((res) => {
        NotificationManager.info('Região alterada.');
        setRegioes((state) =>
          state.map((e) => {
            if (e.Id !== res.data.Id) {
              return e;
            }
            e = res.data;
            return e;
          }),
        );
        close();
      });
  }, [ativo, close, descricao, idRegiao, id_empresa, setRegioes, taxaGratis]);

  useEffect(() => {
    if (regiao) {
      setIdRegiao(regiao.Id);
      setDescricao(regiao.Descricao);
      setTaxaGratis(regiao.TaxaGratis);
      setAtivo(regiao.Ativo);
    }
  }, [modal, regiao]);

  return (
    <>
      <RModal
        open={modal}
        onClose={close}
        title={regiao ? `Editar Região: ${descricao}` : `Cadastar Região`}
        footer={
          <>
            <CustomButton
              onClick={regiao ? editar : cadastrar}
              appearance="primary"
            >
              Salvar
            </CustomButton>
            <CustomButton onClick={close} appearance="ghost">
              Fechar
            </CustomButton>
          </>
        }
      >
        <form>
          <Container>
            <ContainerInterno>
              <label>
                <b style={{ color: theme.colors.textSecondary }}>Descrição</b>
              </label>
              <CustomInput
                type="text"
                value={descricao}
                onChange={setDescricao}
              />
            </ContainerInterno>
            <ContainerInterno>
              <label>
                <b style={{ color: theme.colors.textSecondary }}>
                  Taxa Grátis a partir de
                </b>
              </label>
              <CustomInput
                type="number"
                value={taxaGratis}
                min="0"
                onChange={setTaxaGratis}
              />
            </ContainerInterno>
          </Container>
          {idRegiao !== null && (
            <Container>
              <ContainerInterno>
                <label>
                  <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
                </label>
                <CustomSelectPicker
                  data={data}
                  style={{ width: 200 }}
                  onChange={setAtivo}
                  defaultValue={regiao.Ativo ? 1 : 0}
                  searchable={false}
                />
              </ContainerInterno>
            </Container>
          )}
        </form>
      </RModal>
    </>
  );
};

export default EditarCadastrarRegiao;
